<template>
    <span :class="{ 'font-weight-bold': showMock }">{{ displayValue }}</span>
</template>

<script>
export default {
    name: 'CountColumn',
    props: {
        value: {
            type: Number,
            required: true,
        },
        maxValue: {
            type: Number,
            default: null,
        },
        singleValue: {
            type: Boolean,
            default: false,
        },
        showMock: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        displayValue() {
            // Handle mock case
            if (this.showMock) {
                return 'Mock'
            }

            if (this.singleValue) {
                return this.value
            }

            return `${this.value} / ${this.maxValue}`
        }
    }
}
</script>
